<template>
  <v-card>
    <form-header :fullscreen="false" :title='$lang("reservation-extras.title_create")'></form-header>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="8">
            <v-select
              v-model="selectedExtra"
              :items="propertyExtras.collection"
              :loading="propertyExtras.loading"
              item-value="id"
              item-text="name"
              return-object
              :label="$lang('reservation-extras.fields.select_available_extra')"
              :hint="$lang('reservation-extras.hints.select_available_extra')"
              persistent-hint
            ></v-select>
          </v-col>
          <v-col cols="4" align-self="center">
            <v-btn @click="applyExtra" block color="primary">{{ $lang('main.crud.add') }}</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" xs="12" md="12">
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">{{ $lang('reservation-extras.fields.name') }}</th>
                  <th class="text-left">{{ $lang('reservation-extras.fields.amount') }}</th>
                  <th class="text-left">{{ $lang('reservation-extras.fields.vat_percent') }}</th>
                  <th class="text-right">{{ $lang('main.crud.actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(extra, index) in amountExtras">
                  <td style="width: 50%">
                    <v-text-field
                      v-model="extra.name"
                      dense
                      :error="!!validation[`amount_extras.${index}.name`]"
                      :error-messages="!!validation[`amount_extras.${index}.name`] ? validation[`amount_extras.${index}.name`] : []"
                    />
                  </td>
                  <td style="width: 30%">
                    <v-text-field
                      v-model="extra.amount"
                      type="number"
                      :suffix="formOptions.currency"
                      dense
                      :error="!!validation[`amount_extras.${index}.amount`]"
                      :error-messages="!!validation[`amount_extras.${index}.amount`] ? validation[`amount_extras.${index}.amount`] : []"
                    />
                  </td>
                  <td style="width: 20%">
                    <v-text-field
                      v-model="extra.vat_percent"
                      type="number"
                      suffix="%"
                      dense
                      :error="!!validation[`amount_extras.${index}.vat_percent`]"
                      :error-messages="!!validation[`amount_extras.${index}.vat_percent`] ? validation[`amount_extras.${index}.vat_percent`] : []"
                    />
                  </td>
                  <td>
                    <div class="text-right">
                      <v-icon @click="addExtra()" v-if="index === amountExtras.length - 1" color="success">mdi-plus</v-icon>
                      <v-icon @click="removeExtra(index)" color="error">mdi-minus</v-icon>
                    </div>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-btn color="error" @click="close()">{{ $lang("main.close") }}</v-btn>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="apply()">{{ $lang("main.words.apply") }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from "vuex";
  import extraComputation from "@/pages/reservation-extras/mixins/extras-computation";

  export default {
    name: "AmountExtrasForm",
    props: {
      extras: {
        type: Array,
        required: true,
      },
      formOptions: {
        type: Object,
        required: true,
      },
    },
    mixins: [
      extraComputation
    ],
    data() {
      return {
        amountExtras: [{}],
        selectedExtra: {},
      }
    },
    beforeMount() {
      if (!this.extras.length) {
        return;
      }

      this.amountExtras = this.extras;
    },
    methods: {
      close() {
        this.$emit('close');
      },
      apply() {
        let data = [ ...this.amountExtras ].filter(item => !!item.name && !!item.amount);

        this.$emit('changed', data);
        this.showNotification(this.$lang("main.words.applied"), "success");
      },
      addExtra() {
        this.amountExtras.push({});
      },
      removeExtra(index) {
        if (this.amountExtras[index].is_required) {
          this.showNotification(this.$lang("main.words.required"), "error");
        }

        this.amountExtras.splice(index, 1);

        if (this.amountExtras.length === 0) {
          this.amountExtras = [{}];
        }
      },
      applyExtra() {
        this.amountExtras.push({
          extra_id: this.selectedExtra.id,
          name: this.selectedExtra.name,
          quantity: 1,
          amount: this.computeAmount(this.selectedExtra, this.formOptions),
          vat_percent: this.selectedExtra.vat_percent,
        });
      }
    },
    computed: {
      total() {
        let total = 0;

        this.amountExtras.forEach(item => {
          total += parseFloat(item.amount);
        })

        return total.toFixed(2);
      },
      ...mapState({
        propertyExtras: state => state.propertyExtras.getCollectionRequest,
        validation: state => state.reservations.creationWizardRequest.validation,
      }),
    },
  };
</script>

<style scoped>

</style>
